import * as Yup from 'yup';

export const loginValidationSchema = Yup.object({
    email: Yup.string()
        .email('Invalid email format')
        .matches(/.[!@#$%^&(),.?":{}|<>].*/, 'Email must contain at least one special character')
        .required('Email is required'),
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters long')
        .max(20, 'Password must be less than 20 character'),
    security_code: Yup.number()
        .required("Security code is required")
});